<template>
  <p v-if="!deleted" class="mb-0 d-inline-block message-content">
    <slot name="prefix" />
    <component
      :is="token.type"
      v-for="(token, i) in tokens"
      :key="i"
      class="message-token"
      :data="token.payload"
      :user="user"
    />
  </p>
  <p v-else class="mb-0 d-inline-block message-content">
    <slot name="prefix" />
    <em v-t="'layout.chat.message_removed'" class="grey300--text" />
  </p>
</template>

<script>
import User from '@/store/models/user/User'

export default {
  components: {
    rawtext: () => import('@/components/Chat/ChatContent/ChatContentText'),
    mention: () => import('@/components/Chat/ChatContent/ChatContentMention'),
    emote: () => import('@/components/Chat/ChatContent/ChatContentEmote'),
    url: () => import('@/components/Chat/ChatContent/ChatContentUrl'),
  },
  props: {
    tokens: {
      type: Array,
      required: true,
    },
    user: {
      type: [User, Object],
      default: null,
    },
    deleted: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.message-content {
  color: grey(200);
  line-height: 1.4;
  white-space: break-spaces;
  word-break: break-word;
}
</style>
